define(function () {
	var base_collection = require('./nearest_collection_base');

	return base_collection.extend({
		siteType:'address',
		urlRoot: '/delegate/civics-api/api/property/addresses?MapExtent={Min:{X:{0},Y:{1}},Max:{X:{2},Y:{3}}}&page=[{Start:1,Max:0}]&IsEffective=true&IsExpired=false',
	});
});